@if (formData.formGroup) {
  <div class="input-wrapper"
       [formGroup]="formData.formGroup">
    @if (isLoading) {
      <p-skeleton height="50px"
                  class="mb-2" />

      <label [for]="formData.id"
             class="label skeletonLabel">
        {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
      </label>
    } @else {
      <p-floatlabel variant="on">
        <p-datepicker
          [formControlName]="formData.id"
          [inputId]="formData.id"
          [selectionMode]="formData.selectionMode || 'single'"
          [readonlyInput]="formData.readonlyInput ?? true"
          [showIcon]="formData.showIcon ?? true"
          [dateFormat]="formData.dateFormat || 'dd.mm.yy'"
          [placeholder]="formData.placeholder || ''"
          [showClear]="formData.showClear ?? false"
          [minDate]="formData.minDate"
          [maxDate]="formData.maxDate"
          [showTime]="formData.showTime ?? false"
          [hourFormat]="'24'"
          [style]="datePickerRootStyle"
          [inputStyle]="datePickerInputStyle"
          [panelStyle]="datePickerPanelStyle"
          (onSelect)="onDateSelect($event)"
          (onClear)="onClear()">
        </p-datepicker>

        <label class="on_label"
               for="{{ formData.id }}">
          {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
        </label>
      </p-floatlabel>
    }
  </div>
}

@if (formData.required && checkError()) {
  <p class="message error">
    Dieses Feld ist erforderlich
  </p>
}

@if (formData.infoText) {
  <p class="message info">
    {{ formData.isTranslated ? (formData.infoText | translateSafe) : formData.infoText }}
  </p>
}